import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Competition from "../components/EditCompetition/Competition";
import CompetitionForPartner from "../components/EditCompetition/CompetitionForPartner";
import Loader from "../components/general/Loader";
import NoData from "../components/general/NoData";
import NunitoText from "../components/general/NunitoText";
import ReusableButton from "../components/general/ReusableButton";
import { showWarningSwal } from "../functions/alert";
import { isAdmin } from "../functions/checkrole";
import { deepCopy, populateCompetition } from "../functions/edit";
import {
  getCollectionsListing,
  getCompetitions,
  getDifficultyGroup,
} from "../functions/getData";
export default function EditCompetition() {
  const [loading, setLoading] = useState(true);
  const [firstLoaded, setFirstLoaded] = useState(false);
  const [original, setOriginal] = useState();
  const [competition, setCompetition] = useState();
  const competitionOptions = [];
  const [collectionOptions, setCollectionOptions] = useState([]);
  // const [competitionOptions, setCompetitionOptions] = useState([])
  // const [tagOptions, setTagOptions] = useState([])
  const [difficultyGroupOptions, setDifficultyGroupOptions] = useState([]);
  document.title = "Edit Competition";
  let location = useLocation();
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (location.search.slice(0, 4) === "?id=") {
      getCompetitions(`/${location.search.slice(4)}`, signal)
        .then((c) => {
          //   console.log(makeSureIsArray(c).filter(el=>{
          //      console.log(el)
          //    return el.id === Number(location.search.slice(4))
          // })[0])
          let foundCompetition = populateCompetition(c);
          console.log(foundCompetition);
          console.log(foundCompetition.rounds);
          setOriginal(deepCopy(foundCompetition));
          setCompetition(foundCompetition);
          if (isAdmin()) {
            // getCollections("?status=active&limits=200", signal)
            getCollectionsListing(signal)
              .then((c) => {
                console.log(c);
                //  console.log(c.collectionList.data);
                setCollectionOptions(
                  c.data.map((d) => ({ id: d.id, name: d.name }))
                );
              })
              .catch((e) => console.log(e));
            getDifficultyGroup("?status=active&limits=100", signal)
              .then((d) => {
                setDifficultyGroupOptions(
                  d.TaskDifficultyGroupSLists.data.map((d) => ({
                    id: d.id,
                    name: d.name,
                  }))
                );
              })
              .catch((e) => console.log(e));
          }
        })
        .catch((e) => console.log(e))
        .finally(() => {
          if (!signal.aborted) {
            setLoading(false);
            setFirstLoaded(true);
          }
        });
    } else {
      showWarningSwal("Wrong query");
      if (!signal.aborted) {
        setLoading(false);
        setFirstLoaded(true);
      }
    }
    return () => controller.abort();
  }, [location.search]);
  // console.log(competition, "in edit");
  return (
    <Box className="wrapperBox">
      <div className="formContainer">
        <NunitoText
          value="Edit Competition"
          fontSize={22}
          fontWeight={650}
          
          color='var(--color-text)'
          align="left"
        />
        {loading ? (
          <Loader height={600} />
        ) : competition ? (
          isAdmin() ? (
            <Competition
              original={original}
              setOriginal={setOriginal}
              competition={competition}
              setCompetition={setCompetition}
              difficultyGroupOptions={difficultyGroupOptions}
              competitionOptions={competitionOptions}
              collectionOptions={collectionOptions}
            />
          ) : (
            <CompetitionForPartner
              original={original}
              setOriginal={setOriginal}
              competition={competition}
              setCompetition={setCompetition}
            />
          )
        ) : (
          firstLoaded && <NoData height={600} />
        )}
      </div>
    </Box>
  );
}
